/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 7ffb5907b7c0
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  MessageResponse,
  MessageResponse$zodSchema,
} from "./messageresponse.js";

export type DeleteStreamingProfileGlobals = { cloud_name?: string | undefined };

export const DeleteStreamingProfileGlobals$zodSchema: z.ZodType<
  DeleteStreamingProfileGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type DeleteStreamingProfileRequest = { name: string };

export const DeleteStreamingProfileRequest$zodSchema: z.ZodType<
  DeleteStreamingProfileRequest
> = z.object({
  name: z.string().describe("The name of the streaming profile."),
});

export type DeleteStreamingProfileResponse = MessageResponse | ApiError;

export const DeleteStreamingProfileResponse$zodSchema: z.ZodType<
  DeleteStreamingProfileResponse
> = z.union([
  MessageResponse$zodSchema,
  ApiError$zodSchema,
]);
